import { apiFetch } from '@/lib/api';

export interface OrganizationSettings {
  organization_id: string;
  notification_emails: string | null;
}

export class OrganizationSettingsService {
  /**
   * Get organization settings
   */
  async getSettings(organizationId: string): Promise<OrganizationSettings> {
    const response = await apiFetch(`/api/orgs/${organizationId}/settings`);
    if (!response.ok) {
      throw new Error('Failed to fetch organization settings');
    }
    const result = await response.json();
    return result.data;
  }

  /**
   * Update organization settings
   */
  async updateSettings(
    organizationId: string,
    settings: Partial<Pick<OrganizationSettings, 'notification_emails'>>
  ): Promise<OrganizationSettings> {
    const response = await apiFetch(`/api/orgs/${organizationId}/settings`, {
      method: 'PUT',
      body: JSON.stringify(settings),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Failed to update organization settings' }));
      throw new Error(error.message || 'Failed to update organization settings');
    }

    const result = await response.json();
    return result.data;
  }
}
